module.exports = __webpack_public_path__ + "static/media/area-hundred-percent-icon.66a81e7f.svg";